import {lazy} from 'react';

const DepositViewAsync = lazy(() => import('./DepositView'));

export {DepositViewAsync};
